import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_14069_36515)">
      <path
        d="M10.4167 5.58333C10.3034 5.47007 10.1497 5.40644 9.98952 5.40644C9.82931 5.40644 9.67567 5.47007 9.56237 5.58333L8 7.14571L6.43762 5.58333C6.32368 5.47328 6.17106 5.41238 6.01265 5.41376C5.85424 5.41513 5.70271 5.47867 5.59069 5.59069C5.47867 5.70271 5.41513 5.85424 5.41376 6.01265C5.41238 6.17106 5.47328 6.32368 5.58333 6.43762L7.14571 8L5.58333 9.56237C5.47328 9.67632 5.41238 9.82893 5.41376 9.98734C5.41513 10.1458 5.47867 10.2973 5.59069 10.4093C5.70271 10.5213 5.85424 10.5849 6.01265 10.5862C6.17106 10.5876 6.32368 10.5267 6.43762 10.4167L8 8.85429L9.56237 10.4167C9.67632 10.5267 9.82893 10.5876 9.98734 10.5862C10.1458 10.5849 10.2973 10.5213 10.4093 10.4093C10.5213 10.2973 10.5849 10.1458 10.5862 9.98734C10.5876 9.82893 10.5267 9.67632 10.4167 9.56237L8.85429 8L10.4167 6.43762C10.5299 6.32432 10.5936 6.17068 10.5936 6.01048C10.5936 5.85027 10.5299 5.69663 10.4167 5.58333Z"
        fill="white"
      />
      <path
        d="M8 0.75C6.56609 0.75 5.16437 1.1752 3.97212 1.97185C2.77986 2.76849 1.85061 3.90078 1.30188 5.22554C0.753141 6.55031 0.609567 8.00804 0.88931 9.4144C1.16905 10.8208 1.85955 12.1126 2.87348 13.1265C3.88741 14.1405 5.17923 14.8309 6.5856 15.1107C7.99196 15.3904 9.44969 15.2469 10.7745 14.6981C12.0992 14.1494 13.2315 13.2201 14.0282 12.0279C14.8248 10.8356 15.25 9.43391 15.25 8C15.2479 6.07782 14.4834 4.23496 13.1242 2.87577C11.765 1.51658 9.92218 0.752079 8 0.75ZM8 14.0417C6.80507 14.0417 5.63698 13.6873 4.64343 13.0235C3.64988 12.3596 2.87551 11.416 2.41823 10.312C1.96095 9.20807 1.84131 7.9933 2.07443 6.82133C2.30754 5.64936 2.88296 4.57284 3.7279 3.7279C4.57284 2.88295 5.64936 2.30754 6.82133 2.07442C7.9933 1.8413 9.20808 1.96095 10.312 2.41823C11.416 2.87551 12.3596 3.64988 13.0235 4.64343C13.6873 5.63698 14.0417 6.80507 14.0417 8C14.0399 9.60181 13.4028 11.1375 12.2702 12.2702C11.1375 13.4028 9.60181 14.0399 8 14.0417Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_14069_36515">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CircleCrossIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default CircleCrossIcon;
